import decoder from '../../../lib/decoder';

function ModelBranch() {
    this.id = 0;
    this.prefix = 0;
    this.name = '';
    this.selected = false;
    this.key = '';
}

ModelBranch.create = function (json) {
    if (!json) json = {};

    let model = new ModelBranch();

    model.id = decoder.intValue(json['id'], 0);
    model.prefix = decoder.intValue(json['prefix'], 0);
    model.name = decoder.stringValue(json['name'], '');
    model.key = '' + model.id + '_' + model.prefix;
    model.popularInSearch = decoder.boolValue(json['popularInSearch'], false);
    model.sort = decoder.intValue(json['sort'], 10000);

    return model;
};

export default ModelBranch;